<template>
    <div v-cloak class="compare-wrapper">
        <div v-if="!loaded" class="compare-container loading" style="min-height:1000px">
            <div class="msg">
                <h1>{{ translations.compare01 }} <i class="fa fa-spin fa-circle-o-notch"></i></h1>
                <p>{{ translations.compare02 }}</p>
            </div>
        </div>
        <div v-else-if="loaded && (count <= 0 || dataObjects.length <= 0)">
            <h1>{{ translations.compare03 }}</h1>
        </div>
        <div v-else class="compare" id="compare" style="min-height:1000px">
            <h1><span v-html="translations.compare04"></span>&nbsp;({{ count }})</h1>

            <div class="d-all" v-show="count > 1 && loaded" style="padding-top:20px">
                <p @click="deleteAll"><i class="fa fa-trash"></i> {{ translations.compare05 }}</p>
            </div>

            <div class="compare-grid-wrap sticky" v-show="dataObjects && loaded && count">
                <div class="compare-grid" :style="{ '--cols': count }">
                    <!-- ROW: Produkt -->
                    <div class="rowx grad">
                        <div class="cell legend grad"><strong>{{ translations.compare06 }}</strong></div>
                        <div class="cell" v-for="item in dataObjects" :key="item.id + '-title'">
                            <div class="title" v-if="item.data.variation.name && item.data.variation.name !=''">{{ item.data.variation.name }}</div>
                            <div class="title" v-else>{{ item.data.texts.name1 }}</div>
                            <span class="img">
                                <span>
                                    <img v-if="item.data.images.variation.length" class="lazyload" :data-src="item.data.images.variation[0].urlMiddle" alt="">
                                    <img v-else class="lazyload" :data-src="item.data.images.all[0].urlMiddle" alt="">
                                </span>
                            </span>
                            <span class="price">
                                <span v-if="item.data.prices.specialOffer && (item.data.prices.specialOffer.price.value < item.data.prices.default.unitPrice.value)">
                                    {{ item.data.prices.specialOffer.price.formatted }}
                                </span>
                                <span v-else>{{ item.data.prices.default.unitPrice.formatted }}</span>
                                <del v-if="item.data.prices.specialOffer">
                                    {{ item.data.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                                </del>
                                <del v-else-if="item.data.prices.rrp && item.data.prices.rrp.unitPrice.value > 0 && item.data.prices.rrp.unitPrice.value > item.data.prices.default.unitPrice.value" class="rrp">
                                    {{ item.data.prices.rrp.unitPrice.formatted }}
                                </del>
                            </span>
                            <div class="c2a-btns">
                                <a class="btn grad" :href="item.data | itemURL">{{ translations.compare07 }}</a>
                                <span class="btn rmv" @click="removeItem(item.id)">{{ translations.compare08 }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="compare-grid-wrap" v-show="dataObjects && loaded && count" ref="scroller">
                <div class="compare-grid" :style="{ '--cols': count }" ref="grid">

                    <!-- ROW: Bild -->
                    <div class="rowx images">
                        <div class="cell legend">&nbsp;</div>
                        <div class="cell" v-for="item in dataObjects" :key="item.id">
                            <span class="img">
                                <span>
                                    <img v-if="item.data.images.variation.length" class="lazyload" :data-src="item.data.images.variation[0].urlMiddle" alt="">
                                    <img v-else class="lazyload" :data-src="item.data.images.all[0].urlMiddle" alt="">
                                </span>
                            </span>
                        </div>
                    </div>

                    <!-- ROW: Produkt -->
                    <div class="rowx product">
                        <div class="cell legend"><strong>{{ translations.compare06 }}</strong></div>
                        <div class="cell" v-for="item in dataObjects" :key="item.id + '-title'">
                            <div class="title" v-if="item.data.variation.name && item.data.variation.name !=''">{{ item.data.variation.name }}</div>
                            <div class="title" v-else>{{ item.data.texts.name1 }}</div>

                            <template v-for="varProp in item.data.variationProperties" v-if="item.data.variationProperties && varProp.id == 18">
                                <template v-for="varProp in varProp.properties" v-if="varProp.id == 99 && varProp.values && varProp.values.value != ''">
                                    <span class="sub small">{{ varProp.values.value }}</span>
                                </template>
                            </template>

                            <div class="c2a-btns">
                                <a class="btn grad" :href="item.data | itemURL">{{ translations.compare07 }}</a>
                                <span class="btn rmv" @click="removeItem(item.id)">{{ translations.compare08 }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- ROW: Preis -->
                    <div class="rowx price">
                        <div class="cell legend">{{ translations.compare09 }}</div>
                        <div class="cell" v-for="item in dataObjects" :key="item.id + '-price'">
                            <span>
                                <span v-if="item.data.prices.specialOffer && (item.data.prices.specialOffer.price.value < item.data.prices.default.unitPrice.value)">
                                    {{ item.data.prices.specialOffer.price.formatted }}
                                </span>
                                <span v-else>{{ item.data.prices.default.unitPrice.formatted }}</span>
                                <del v-if="item.data.prices.specialOffer">
                                    {{ item.data.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                                </del>
                                <del v-else-if="item.data.prices.rrp && item.data.prices.rrp.unitPrice.value > 0 && item.data.prices.rrp.unitPrice.value > item.data.prices.default.unitPrice.value" class="rrp">
                                    {{ item.data.prices.rrp.unitPrice.formatted }}
                                </del>
                            </span>
                        </div>
                    </div>

                    <!-- ROW: Bewertungen -->
                    <div class="rowx ratings">
                        <div class="cell legend">{{ translations.compare10 }}</div>
                        <div class="cell" v-for="item in dataObjects" :key="item.id + '-rating'">
                            <span class="rating-wrapper">
                                <template v-if="item.data.item.feedbackCount">
                                    <span class="rating">
                                        <span class="blank">
                                            <i v-for="n in 5" :key="'b' + n" class="fa fa-star" aria-hidden="true"></i>
                                        </span>
                                        <span class="rate" :style="{ width: (item.data.item.feedbackDecimal * 20) + '%' }">
                                            <i v-for="n in 5" :key="'r' + n" class="fa fa-star" aria-hidden="true"></i>
                                        </span>
                                    </span>
                                    <span>({{ item.data.item.feedbackCount }})</span>
                                </template>

                                <template v-else>
                                    <span class="rating no">-</span>
                                </template>
                            </span>
                        </div>
                    </div>

                    <!-- ROW: Verfügbarkeit -->
                    <div class="rowx av">
                        <div class="cell legend">{{ translations.compare11 }}</div>
                        <div class="cell" v-for="item in dataObjects" :key="item.id + '-avail'">
                            <span v-if="item.data.variation.availability && item.data.variation.availability.names && item.data.variation.availability.names.name" :class="'av' + item.data.variation.availability.id">
                                {{ item.data.variation.availability.names.name.replace('Lieferzeit ', '') }}
                            </span>
                            <span v-else>-</span>
                        </div>
                    </div>

                    <!-- GROUPS + ROWS: Dynamische Eigenschaften -->
                    <div class="group-block" v-for="group in groupedVariationProperties" :key="'group-'+group.groupName">
                        <!-- Headline row spanning all grid columns -->
                        <div class="rowx headline grad">
                            <div class="cell legend headline-cell grad">
                                <strong>{{ group.groupName }}</strong>
                            </div>
                        </div>

                        <!-- Property rows -->
                        <div class="rowx props" v-for="propName in group.props" :key="'prop-'+propName">
                            <div class="cell legend"><span>{{ propName }}</span></div>
                            <div class="cell" v-for="item in dataObjects" :key="item.id + '-' + propName">
                                <template v-if="getPropertyValue(item, group.groupId, propName) === 'Ja'">
                                    <i class="fa fa-check"></i>
                                </template>
                                <template v-else-if="getPropertyValue(item, group.groupId, propName) === 'Nein'">
                                    <i class="fa fa-times"></i>
                                </template>
                                <template v-else>
                                    <span v-html="getPropertyValue(item, group.groupId, propName) || '-'"></span>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-all" v-show="count > 1 && loaded" style="padding-top:20px">
                <p @click="deleteAll"><i class="fa fa-trash"></i> {{ translations.compare12 }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        inheritAttrs: false,
        props: {
            varGroupIds: {
                type: Array,
                default: () => []
            },
            scrollTriggerY: {
                type: Number,
                default: 500
            },
            scrollBodyClass: {
                type: String,
                default: ''
            },
            translations: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                dataObjects: [],
                loaded: false,
                count: null,
                numericVarGroupIds: [],
                _scrollHandlers: [],
                _dragHandlers: [],
                _isSyncingScrollX: false,
                _onWinScroll: null,
                _isBodyOverThreshold: false,
                _bodyScrollClass: null
            };
        },
        mounted() {
            this.numericVarGroupIds = this.varGroupIds.map(id => Number(id));

            this.$nextTick(() => {
                this.syncWhenScrollingHorizontally();
                this.setupDragToScroll();
            });

            const items = this.getCompareItems();

            if (items.length === 0) {
                this.count = 0;
                this.$nextTick(() => { this.loaded = true; });
                return;
            }

            this.count = items.length;
            const query = items.map(id => `variationIds[]=${id}`).join("&");

            fetch(`/rest/io/variations?${query}&template=fubar`)
                .then(res => res.json())
                .then(result => {
                    this.dataObjects = result.data.documents.reverse();
                    this.count = this.dataObjects.length;
                    this.loaded = true;
                    this.$nextTick(() => this.updateList());
                })
                .catch(() => {
                    this.count = 0;
                    this.loaded = true;
                });

            this._bodyScrollClass = this.scrollBodyClass || `scrolled-${this.scrollTriggerY}`;

            this._onWinScroll = () => {
                const y = window.pageYOffset || document.documentElement.scrollTop || 0;
                const over = y > this.scrollTriggerY;
                if (over !== this._isBodyOverThreshold) {
                    this._isBodyOverThreshold = over;
                    const b = document.body;
                    if (b) {
                        if (over) {
                            b.classList.add(this._bodyScrollClass);
                        } else {
                            b.classList.remove(this._bodyScrollClass);
                        }
                    }
                }
            };

            window.addEventListener('scroll', this._onWinScroll, { passive: true });
            this._onWinScroll();
        },
        beforeDestroy() {
            if (this._onWinScroll) {
                window.removeEventListener('scroll', this._onWinScroll);
                this._onWinScroll = null;
            }

            if (document && document.body && this._bodyScrollClass) {
                document.body.classList.remove(this._bodyScrollClass);
            }

            if (Array.isArray(this._scrollHandlers)) {
                this._scrollHandlers.forEach(({ el, handler }) => el.removeEventListener('scroll', handler));
                this._scrollHandlers = [];
            }

            if (Array.isArray(this._dragHandlers)) {
                this._dragHandlers.forEach(({ el, handlers }) => {
                    if (!el || !handlers) return;
                    el.removeEventListener('pointerdown', handlers.onPointerDown);
                    el.removeEventListener('pointermove', handlers.onPointerMove);
                    el.removeEventListener('pointerup', handlers.endDrag);
                    el.removeEventListener('pointerleave', handlers.endDrag);
                    el.removeEventListener('pointercancel', handlers.endDrag);
                });
                this._dragHandlers = [];
            }
        },
        computed: {
            // Resolves all property values for all items upfront into a nested lookup map.
            // Shape: { [itemId]: { [groupId]: { [propName]: resolvedValue } } }
            resolvedPropertyValues() {
                const idSet = new Set(this.numericVarGroupIds);
                const result = {};

                for (const item of this.dataObjects) {
                    const itemMap = {};
                    const vps = (item && item.data && item.data.variationProperties) || [];

                    for (const group of vps) {
                        if (!idSet.has(group.id)) continue;

                        if (!itemMap[group.id]) itemMap[group.id] = {};

                        const props = Array.isArray(group.properties) ? group.properties : [];
                        for (const prop of props) {
                            const propName =
                                (prop.names && prop.names.name) ||
                                prop.name ||
                                ('Eigenschaft ' + (prop.id != null ? prop.id : '?'));

                            // First encountered value for a propName within this group wins
                            if (!(propName in itemMap[group.id])) {
                                itemMap[group.id][propName] = this._resolvePropValue(prop);
                            }
                        }
                    }

                    result[item.id] = itemMap;
                }

                return result;
            },

            // Builds sorted, empty-row-filtered groups using resolvedPropertyValues.
            groupedVariationProperties() {
                const ids = this.numericVarGroupIds || [];
                if (!ids.length || !Array.isArray(this.dataObjects)) return [];

                const groupsById = new Map();
                ids.forEach(id => {
                    groupsById.set(id, {
                        groupId: id,
                        groupName: null,
                        props: [],
                        _propSet: new Set(),
                        _propPositions: new Map()
                    });
                });

                for (const item of this.dataObjects) {
                    const vps = (item && item.data && item.data.variationProperties) || [];

                    for (const group of vps) {
                        const gid = group && group.id;
                        if (!groupsById.has(gid)) continue;

                        const entry = groupsById.get(gid);

                        if (!entry.groupName) {
                            entry.groupName =
                                (group.names && group.names.name) ||
                                group.name ||
                                ('Gruppe ' + gid);
                        }

                        const props = Array.isArray(group.properties) ? group.properties : [];
                        for (const prop of props) {
                            const propName =
                                (prop.names && prop.names.name) ||
                                prop.name ||
                                ('Eigenschaft ' + (prop.id != null ? prop.id : '?'));

                            if (!entry._propSet.has(propName)) {
                                entry._propSet.add(propName);
                                entry.props.push(propName);
                                entry._propPositions.set(propName, prop.position ?? 0);
                            }
                        }
                    }
                }

                const result = [];
                ids.forEach(id => {
                    const entry = groupsById.get(id);
                    if (!entry || !entry.props.length) return;

                    entry.props.sort((a, b) =>
                        (entry._propPositions.get(a) ?? 0) - (entry._propPositions.get(b) ?? 0)
                    );

                    // Filter out props where every item resolves to '-'
                    const visibleProps = entry.props.filter(propName =>
                        this.dataObjects.some(item => {
                            const val = ((this.resolvedPropertyValues[item.id] || {})[id] || {})[propName];
                            return val && val !== '-';
                        })
                    );

                    if (visibleProps.length) {
                        result.push({
                            groupId: id,
                            groupName: entry.groupName || `Gruppe ${id}`,
                            props: visibleProps
                        });
                    }
                });

                return result;
            }
        },
        methods: {
            // Raw value resolver for a single prop object — used by resolvedPropertyValues.
            _resolvePropValue(prop) {
                const values = prop.values;

                if (Array.isArray(values)) {
                    const parts = values.map(v => {
                        if (v == null) return null;
                        if (typeof v === 'string') return v.trim() || null;
                        if (typeof v === 'number') return String(v);
                        if (typeof v === 'object') {
                            if ('value' in v) {
                                const vv = v.value;
                                if (vv == null) return null;
                                const s = typeof vv === 'string' ? vv.trim() : String(vv);
                                return s || null;
                            }
                            if (v.names && v.names.name) return String(v.names.name);
                            if ('name' in v) return String(v.name);
                        }
                        return null;
                    }).filter(Boolean);

                    return parts.length ? parts.join(', ') : '-';
                }

                if (values && typeof values === 'object') {
                    if ('value' in values) {
                        const vv = values.value;
                        if (vv == null) return '-';
                        if (typeof vv === 'string') return vv.trim() || '-';
                        return String(vv);
                    }
                    if (values.names && values.names.name) return String(values.names.name);
                    return '-';
                }

                // Only fall back to prop.value when prop.values is completely absent
                // (undefined). If prop.values is explicitly null, treat it as "no value" —
                // plentymarkets may set prop.value to a property-definition default that
                // doesn't belong to this specific variation, causing false duplicates.
                if (values === undefined && prop.value != null) {
                    if (typeof prop.value === 'string') return prop.value.trim() || '-';
                    return String(prop.value);
                }

                return '-';
            },

            // Temporary debug helper — call this.debugProps() in browser console to
            // inspect the raw variationProperties and resolved values.
            debugProps() {
                console.group('CompareList debug');
                this.dataObjects.forEach(item => {
                    const id = item && item.id;
                    const name = (item && item.data && item.data.texts && item.data.texts.name1) || id;
                    console.group(`Item ${id} — ${name}`);
                    console.log('variationProperties:', JSON.parse(JSON.stringify((item && item.data && item.data.variationProperties) || [])));
                    console.log('resolvedPropertyValues:', JSON.parse(JSON.stringify(this.resolvedPropertyValues[id] || {})));
                    console.groupEnd();
                });
                console.log('groupedVariationProperties:', JSON.parse(JSON.stringify(this.groupedVariationProperties)));
                console.groupEnd();
            },

            // O(1) lookup into the pre-computed map — now group-aware to prevent
            // values leaking across groups that share the same property name.
            getPropertyValue(item, groupId, propName) {
                return ((this.resolvedPropertyValues[item.id] || {})[groupId] || {})[propName] || '-';
            },

            getCompareItems() {
                try {
                    return JSON.parse(localStorage.getItem("compareListItems")) || [];
                } catch (e) {
                    return [];
                }
            },
            updateList() {
                this.$nextTick(() => {
                    if (!Array.isArray(this._scrollHandlers) || this._scrollHandlers.length === 0) {
                        if (!Array.isArray(this._scrollHandlers)) this._scrollHandlers = [];
                        this.syncWhenScrollingHorizontally();
                    }
                    this.setupDragToScroll();
                });
            },
            deleteAll() {
                if (!confirm(this.translations.compare13.replace(':count', this.count))) return;

                localStorage.setItem("compareListItems", "[]");
                this.count = 0;
                this.dataObjects = [];

                handleCountItemsCompare();

                if (typeof NotificationService !== "undefined") {
                    NotificationService.success(
                        '<i class="fa fa-check"></i> ' + this.translations.compare14
                    ).closeAfter(6000);
                }
            },
            removeItem(id) {
                id = id.toString();

                const storedItems = JSON.parse(localStorage.getItem("compareListItems")) || [];
                const updatedItems = storedItems.filter(itemId => itemId.toString() !== id);
                localStorage.setItem("compareListItems", JSON.stringify(updatedItems));

                this.dataObjects = this.dataObjects.filter(obj => obj.id.toString() !== id);
                this.count = updatedItems.length;

                this.$nextTick(() => this.updateList());

                handleCountItemsCompare();

                if (typeof(NotificationService) !== "undefined") {
                    NotificationService.warn(
                        '<i class="fa fa-check" aria-hidden="true"></i> ' + this.translations.compare15
                    ).closeAfter(5000);
                }
            },
            syncWhenScrollingHorizontally() {
                if (!Array.isArray(this._scrollHandlers)) this._scrollHandlers = [];

                const wraps = Array.from(this.$el.querySelectorAll('.compare-grid-wrap')).filter(Boolean);
                if (!wraps.length || this._scrollHandlers.length) return;

                const onScroll = (srcEl) => {
                    if (this._isSyncingScrollX) return;

                    const left = srcEl.scrollLeft;
                    this._isSyncingScrollX = true;

                    for (const el of wraps) {
                        if (el === srcEl) continue;
                        if (el.scrollLeft !== left) el.scrollLeft = left;
                    }

                    requestAnimationFrame(() => { this._isSyncingScrollX = false; });
                };

                wraps.forEach((el) => {
                    const handler = () => onScroll(el);
                    el.addEventListener('scroll', handler, { passive: true });
                    this._scrollHandlers.push({ el, handler });
                });
            },
            isInteractive(el) {
                return !!(el && el.closest && el.closest('a,button,input,textarea,select,[role="button"],.btn'));
            },
            setupDragToScroll() {
                if (!Array.isArray(this._dragHandlers)) this._dragHandlers = [];

                const wraps = Array.from(this.$el.querySelectorAll('.compare-grid-wrap')).filter(Boolean);
                wraps.forEach((el) => {
                    if (el._dragBound) return;

                    const state = { down: false, startX: 0, startLeft: 0, moved: false };

                    const onPointerDown = (e) => {
                        if (!e.isPrimary) return;
                        if (this.isInteractive(e.target)) return;

                        state.down = true;
                        state.moved = false;
                        state.startX = e.clientX;
                        state.startLeft = el.scrollLeft;

                        el.classList.add('dragging');
                        if (el.setPointerCapture) el.setPointerCapture(e.pointerId);
                    };

                    const onPointerMove = (e) => {
                        if (!state.down) return;
                        const dx = e.clientX - state.startX;
                        if (Math.abs(dx) > 3) state.moved = true;
                        el.scrollLeft = state.startLeft - dx;

                        if (e.cancelable) e.preventDefault();
                    };

                    const endDrag = (e) => {
                        if (!state.down) return;
                        state.down = false;
                        el.classList.remove('dragging');
                        if (el.releasePointerCapture) el.releasePointerCapture(e.pointerId);

                        if (state.moved) {
                            const blockClick = (evt) => {
                                evt.stopPropagation();
                                evt.preventDefault();
                                el.removeEventListener('click', blockClick, true);
                            };
                            el.addEventListener('click', blockClick, true);
                        }
                    };

                    el.addEventListener('pointerdown', onPointerDown);
                    el.addEventListener('pointermove', onPointerMove, { passive: false });
                    el.addEventListener('pointerup', endDrag);
                    el.addEventListener('pointerleave', endDrag);
                    el.addEventListener('pointercancel', endDrag);

                    this._dragHandlers.push({ el, handlers: { onPointerDown, onPointerMove, endDrag } });
                    el._dragBound = true;
                });
            }
        }
    }
</script>
